import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnBD: CultureInfo = {
  name: 'en-BD',
  displayName: 'English (Bangladesh)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-BD',
  parent: CultureInfoEn
};
